var assign = require('./assign')

var extend = assign

module.exports = extend



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/object/extend.js
// module id = GEqi
// module chunks = 94